/* Free Life Labs — Shop page behaviour
   Retail: category filter, variant pick, qty stepper, AJAX add (Seal selling plan respected).
   Wholesale: quick-order tiers, running subtotal, free-shipping progress, materials + samples.
   Prices are read from the DOM so Sami's rewritten storefront prices are used, not hardcoded values. */
(function () {
  "use strict";

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (format || "${{amount}}").replace("{{amount}}", parts.join("."));
  };

  function init(root) {
    if (!root || root.dataset.flsReady === "true") return;
    root.dataset.flsReady = "true";

    var settings = JSON.parse(root.querySelector("[data-fls-settings]").textContent);
    var moneyFormat = settings.moneyFormat;
    var freeShipping = settings.freeShippingCents;

    /* ---------------- category filter ---------------- */
    /* Only the top .fls-area chips filter. Product cards also carry data-fls-area for
       matching — do NOT bind filter clicks on cards, or Subscribe/ATC clicks filter the grid. */
    var areaButtons = root.querySelectorAll(".fls-area[data-fls-area]");
    if (root.getAttribute("data-fls-b2b") === "1") {
      root.querySelectorAll("[data-fls-sub]").forEach(function (el) { el.hidden = true; });
      root.querySelectorAll("[data-fls-sub-plan]").forEach(function (el) {
        el.value = "";
        el.disabled = true;
      });
      root.querySelectorAll("[data-fls-sub-toggle]").forEach(function (el) { el.checked = false; });
    }

    var cards = root.querySelectorAll("[data-fls-card]");
    var resultsCount = root.querySelector("[data-fls-count]");
    var clearBtn = root.querySelector("[data-fls-clear]");
    var activeArea = "all";

    function applyFilter() {
      var shown = 0;
      cards.forEach(function (card) {
        var match = activeArea === "all" || card.dataset.flsArea === activeArea;
        card.hidden = !match;
        if (match) shown++;
      });
      areaButtons.forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(btn.dataset.flsArea === activeArea));
      });
      if (resultsCount) {
        var label = root.querySelector('.fls-area[data-fls-area="' + activeArea + '"]');
        resultsCount.textContent =
          activeArea === "all"
            ? "All products (" + shown + ")"
            : (label ? label.dataset.flsAreaName : "") + " (" + shown + ")";
      }
      if (clearBtn) clearBtn.hidden = activeArea === "all";
    }

    areaButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        activeArea = activeArea === btn.dataset.flsArea ? "all" : btn.dataset.flsArea;
        applyFilter();
      });
    });
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        activeArea = "all";
        applyFilter();
      });
    }
    if (areaButtons.length) applyFilter();

    /* ---------------- steppers ---------------- */
    root.addEventListener("click", function (event) {
      var step = event.target.closest("[data-fls-step]");
      if (!step) return;
      var wrap = step.closest("[data-fls-stepper]");
      var input = wrap.querySelector("input");
      var min = parseInt(input.min || "1", 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.flsStep, 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    /* ---------------- retail + wholesale size / variant selection ---------------- */
    root.querySelectorAll("[data-fls-variants]").forEach(function (group) {
      var card = group.closest("[data-fls-card]");
      group.querySelectorAll("[data-fls-variant]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          group.querySelectorAll("[data-fls-variant]").forEach(function (b) {
            b.setAttribute("aria-pressed", String(b === btn));
          });
          var idInput = card.querySelector("[data-fls-variant-id]");
          if (idInput) idInput.value = btn.dataset.flsVariant;

          /* Retail compare-at path */
          var now = card.querySelector("[data-fls-price-now]");
          var was = card.querySelector("[data-fls-price-was]");
          if (now && btn.dataset.flsPrice) now.textContent = btn.dataset.flsPrice;
          if (was) {
            was.textContent = btn.dataset.flsCompare || "";
            was.hidden = !btn.dataset.flsCompare;
          }

          /* Wholesale case size path (separate case SKUs on one card) */
          if (btn.dataset.flsPriceCents) {
            card.dataset.flsPriceCents = btn.dataset.flsPriceCents;
          }
          if (btn.dataset.flsUnits) {
            card.dataset.flsUnits = btn.dataset.flsUnits;
          }
          if (btn.dataset.flsHandle) {
            card.dataset.flsHandle = btn.dataset.flsHandle;
          }
          if (btn.dataset.flsProductId) {
            card.dataset.flsProductId = btn.dataset.flsProductId;
          }
          /* Drop prior tiers — Sami volume pricing for the newly selected product is the source of truth. */
          delete card.dataset.flsTiers;
          var qprice = card.querySelector("[data-fls-qprice]");
          if (qprice && btn.dataset.flsPrice) qprice.textContent = btn.dataset.flsPrice;
          var qunit = card.querySelector("[data-fls-qunit]");
          if (qunit && btn.dataset.flsUnitPrice && btn.dataset.flsUnits) {
            qunit.textContent =
              btn.dataset.flsUnitPrice +
              " per unit · " +
              btn.dataset.flsUnits +
              " units per case";
          }
          var learn = card.querySelector("[data-fls-learn]");
          var media = card.querySelector("[data-fls-card-media]");
          var name = card.querySelector("[data-fls-card-name]");
          if (btn.dataset.flsUrl) {
            if (learn) learn.setAttribute("href", btn.dataset.flsUrl);
            if (media) media.setAttribute("href", btn.dataset.flsUrl);
            if (name) name.setAttribute("href", btn.dataset.flsUrl);
          }
          var img = card.querySelector("[data-fls-card-img]");
          if (img && btn.dataset.flsImg) img.setAttribute("src", btn.dataset.flsImg);

          var tryWrap = card.querySelector("[data-fls-try-wrap]");
          var tryProp = card.querySelector("[data-fls-try-prop]");
          var tryFlag = card.querySelector("[data-fls-try-flag]");
          var isTry = btn.dataset.flsTry === "1";
          if (isTry) card.setAttribute("data-fls-try50", "1");
          else card.removeAttribute("data-fls-try50");
          card.classList.toggle("fls-card--try", isTry);
          if (tryWrap) tryWrap.hidden = !isTry;
          if (tryProp) tryProp.disabled = !isTry;
          if (tryFlag) tryFlag.hidden = !isTry;
          var tryDeal = card.querySelector("[data-fls-try-deal]");
          if (tryDeal && isTry && btn.dataset.flsTryPrice) {
            tryDeal.textContent = "First case " + btn.dataset.flsTryPrice;
          }

          applyVolumeTiers(card);

          /* Re-run case reprice if available on this card */
          if (typeof repriceCase === "function") repriceCase(card);
          else card.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });

    /* ---------------- AJAX add to cart ---------------- */
    function refreshCart(openDrawer) {
      var drawer = document.querySelector("cart-drawer");
      var bubble = document.getElementById("cart-icon-bubble");
      var wanted = [];
      if (drawer) wanted.push("cart-drawer");
      if (bubble) wanted.push("cart-icon-bubble");
      if (!wanted.length) return Promise.resolve();
      /* Use root URL — collection templates 404 on ?sections=. */
      return fetch((window.Shopify.routes.root || "/") + "?sections=" + wanted.join(","))
        .then(function (r) {
          if (!r.ok) throw new Error("sections " + r.status);
          return r.json();
        })
        .then(function (sections) {
          if (sections["cart-drawer"] && drawer) {
            var html = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
            var fresh = html.querySelector("cart-drawer");
            if (fresh) {
              drawer.innerHTML = fresh.innerHTML;
              if (fresh.classList.contains("is-empty")) drawer.classList.add("is-empty");
              else drawer.classList.remove("is-empty");
              var overlay = drawer.querySelector("#CartDrawer-Overlay");
              if (overlay && typeof drawer.close === "function") {
                overlay.addEventListener("click", drawer.close.bind(drawer));
              }
            }
            if (openDrawer !== false) {
              if (typeof drawer.open === "function") drawer.open();
              else drawer.classList.add("animate", "active");
              document.body.classList.add("overflow-hidden");
            }
          }
          if (sections["cart-icon-bubble"] && bubble) {
            /* Section HTML is wrapped in .shopify-section; the #cart-icon-bubble id
               lives on the header <a>, not inside the section (Dawn pattern). */
            var b = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
            var sectionEl = b.querySelector(".shopify-section") || b.body;
            if (sectionEl) bubble.innerHTML = sectionEl.innerHTML;
          }
        })
        .catch(function () {
          /* Fallback: still bump the bag count from cart.js so wholesale stays current. */
          return fetch((window.Shopify.routes.root || "/") + "cart.js")
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (!bubble) return;
              var count = (cart && cart.item_count) || 0;
              var existing = bubble.querySelector(".cart-count-bubble");
              if (count <= 0) {
                if (existing) existing.remove();
                return;
              }
              if (!existing) {
                existing = document.createElement("div");
                existing.className = "cart-count-bubble";
                bubble.appendChild(existing);
              }
              existing.innerHTML =
                (count < 100 ? '<span aria-hidden="true">' + count + "</span>" : "") +
                '<span class="visually-hidden">' + count + " items</span>";
            })
            .catch(function () { return null; });
        });
    }

    function isB2bSubBlock(msg) {
      msg = String(msg || "");
      return /B2B/i.test(msg) && /one-time/i.test(msg) || /selling plan/i.test(msg) && /not available/i.test(msg);
    }

    function showFlsCartErr(button, msg) {
      if (!button) return;
      var host = button.parentElement || (button.closest && button.closest("[data-fls-form]")) || button;
      var box = host.querySelector("[data-fls-cart-err]");
      if (!box) {
        box = document.createElement("div");
        box.setAttribute("data-fls-cart-err", "");
        box.style.cssText = "margin-top:8px;font:600 13px/1.45 'Public Sans',sans-serif;color:#B04A12;width:100%;flex-basis:100%";
        host.appendChild(box);
      }
      box.textContent = msg || "";
    }

    function addItems(items, button, onDone, openDrawer, allowSubRetry) {
      if (!items.length) return;
      var original = button ? button.textContent : "";
      if (button) { button.disabled = true; button.textContent = "Adding\u2026"; }
      if (allowSubRetry === undefined) allowSubRetry = true;
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) {
              var err = new Error((data && data.description) || "add failed");
              err.payload = data;
              throw err;
            }
            return data;
          });
        })
        .then(function () {
          /* Open the side cart immediately so wholesale does not wait on section refresh. */
          if (openDrawer !== false) {
            var drawerNow = document.querySelector("cart-drawer");
            if (drawerNow) {
              try {
                if (typeof drawerNow.open === "function") drawerNow.open();
                else drawerNow.classList.add("animate", "active");
                document.body.classList.add("overflow-hidden");
              } catch (e) {}
            }
          }
          return refreshCart(openDrawer).catch(function (err) {
            console.warn("[fls] cart UI refresh failed", err);
            var drawer = document.querySelector("cart-drawer");
            if (openDrawer !== false && drawer && typeof drawer.open === "function") {
              try { drawer.open(); } catch (e) {}
            }
          });
        })
        .then(function () {
          if (typeof refreshShipBar === "function") refreshShipBar();
          if (typeof refreshCartCases === "function") refreshCartCases();
          if (button) {
            showFlsCartErr(button, "");
            button.textContent = "Added";
            setTimeout(function () { button.disabled = false; button.textContent = original; }, 1600);
          }
          if (onDone) onDone(true);
        })
        .catch(function (err) {
          console.warn("[fls] add to cart failed", err);
          var msg = (err && err.payload && (err.payload.description || err.payload.message)) || (err && err.message) || "Could not add that to the cart.";
          if (msg === "add failed") msg = "Could not add that to the cart.";
          /* B2B company accounts cannot use selling plans — retry once as one-time. */
          var hadPlan = items.some(function (it) { return it && it.selling_plan; });
          if (allowSubRetry && hadPlan && isB2bSubBlock(msg)) {
            var once = items.map(function (it) {
              var copy = {};
              for (var k in it) if (Object.prototype.hasOwnProperty.call(it, k) && k !== "selling_plan") copy[k] = it[k];
              return copy;
            });
            var form = button && button.closest && button.closest("[data-fls-form]");
            var toggle = form && form.querySelector("[data-fls-sub-toggle]");
            var planInput = form && form.querySelector("[data-fls-sub-plan]");
            if (toggle) toggle.checked = false;
            if (planInput) { planInput.value = ""; planInput.disabled = true; }
            if (form) {
              var block = form.querySelector("[data-fls-sub]");
              if (block && typeof block.dispatchEvent === "function") {
                try { block.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) {}
              }
            }
            showFlsCartErr(button, "Subscribe isn’t available on this business account — adding as a one-time purchase.");
            return addItems(once, button, onDone, openDrawer, false);
          }
          if (button) {
            button.disabled = false;
            button.textContent = original;
            showFlsCartErr(button, msg);
          }
          if (onDone) onDone(false);
        });
    }

    function submitFlsForm(form, triggerBtn) {
      if (!form) return;
      var card = form.closest("[data-fls-card]");
      var idEl = form.querySelector("[data-fls-variant-id]");
      var qtyEl = form.querySelector("input[name='quantity']");
      var id = idEl ? Number(idEl.value) : 0;
      if (!id) {
        console.warn("[fls] missing variant id");
        return;
      }
      var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
      var item = { id: id, quantity: qty };

      /* Only our Subscribe toggle may attach a selling plan — ignore Seal-injected inputs. */
      var planInput = form.querySelector("[data-fls-sub-plan]");
      if (planInput && !planInput.disabled && planInput.value) {
        var planId = Number(planInput.value);
        if (planId > 0) item.selling_plan = planId;
      }

      /* Pre-order products: line item property so the cart, checkout and fulfillment all see it. */
      if (form.hasAttribute("data-fls-preorder")) {
        item.properties = Object.assign({}, item.properties || {}, { "Pre-order": "Ships starting Dec 1" });
      }

      if (card && card.getAttribute("data-fls-try50") === "1") {
        item.properties = Object.assign({}, item.properties || {}, { _fll_first_case_try: "1" });
        var tryNote = form.querySelector("[data-fls-try-qtynote]");
        if (tryNote) tryNote.hidden = qty <= 1;
      }

      /* Wholesale: keep the page and sticky ship bar; Open cart is on the bar.
         Retail has no bar, so still open the side cart. */
      addItems(
        [item],
        triggerBtn || form.querySelector("[data-fls-add]"),
        function () {
          revealMaterialNudges(card);
        },
        !shipBar
      );
      if (card) card.dispatchEvent(new CustomEvent("fls:added", { bubbles: true }));
    }

    root.querySelectorAll("[data-fls-form]").forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          submitFlsForm(form, form.querySelector("[data-fls-add]"));
        },
        true
      );
    });

    /* Click path beats Seal/theme submit hijacks that never fire our bubble listener. */
    root.addEventListener(
      "click",
      function (event) {
        var btn = event.target.closest("[data-fls-add]");
        if (!btn || btn.disabled) return;
        var form = btn.closest("[data-fls-form]");
        if (!form || !root.contains(form)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        submitFlsForm(form, btn);
      },
      true
    );

    /* Show a gentle note when first-try qty goes above 1 (no cart redirect). */
    root.querySelectorAll("[data-fls-card][data-fls-try50='1']").forEach(function (card) {
      var input = card.querySelector("input[name='quantity']");
      var note = card.querySelector("[data-fls-try-qtynote]");
      if (!input || !note) return;
      function syncTryNote() {
        var q = parseInt(input.value, 10) || 1;
        note.hidden = q <= 1;
      }
      input.addEventListener("input", syncTryNote);
      input.addEventListener("change", syncTryNote);
      card.querySelectorAll("[data-fls-step]").forEach(function (btn) {
        btn.addEventListener("click", function () { setTimeout(syncTryNote, 0); });
      });
    });

    /* ---------------- wholesale: case tiers + materials ---------------- */
    function hideSamiTables(card) {
      if (!card) return;
      card.querySelectorAll("table").forEach(function (table) {
        table.setAttribute("hidden", "hidden");
        table.style.display = "none";
      });
    }

    function volumeTiersForProduct(productId) {
      var pid = String(productId || "");
      if (!pid) return [];
      var store = window.Samita && Samita.Wholesale && Samita.Wholesale.volumePricing;
      if (!store) return [];
      var out = [];
      Object.keys(store).forEach(function (key) {
        var packed = store[key];
        var rule = packed && (packed[key] || packed);
        if (!rule || !rule.configs) return;
        var ids = ((((rule.product_configs || {}).apply_product || {}).manual || {}).ids) || [];
        var match = false;
        for (var i = 0; i < ids.length; i++) {
          if (String(ids[i]) === pid) { match = true; break; }
        }
        if (!match) return;
        var discounts = (((rule.configs || {}).volume_discount || {}).discounts) || [];
        discounts.forEach(function (d) {
          var min = parseInt(d.from_qty, 10) || 1;
          var dollars = parseFloat(d.value);
          if (isNaN(dollars)) return;
          out.push({ min: min, total: Math.round(dollars * 100) });
        });
      });
      out.sort(function (a, b) { return a.min - b.min; });
      return out;
    }

    function tiersFor(el) {
      try { return JSON.parse(el.dataset.flsTiers || "[]"); } catch (e) { return []; }
    }

    function renderCaseTiers(wrap, tiers, units) {
      if (!wrap) return;
      wrap.innerHTML = "";
      if (!tiers || !tiers.length) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      wrap.removeAttribute("hidden");
      units = parseInt(units, 10) || 12;
      var blurb = document.createElement("p");
      blurb.className = "fls-tiers-blurb";
      blurb.textContent = "Order More and Save";
      wrap.appendChild(blurb);
      var head = document.createElement("div");
      head.className = "fls-tiers__head";
      head.innerHTML = "<span>Cases</span><span>Per unit</span><span>Case</span>";
      wrap.appendChild(head);
      tiers.forEach(function (t) {
        var min = parseInt(t.min, 10) || 0;
        var unit = parseInt(t.unit, 10) || 0;
        var row = document.createElement("div");
        row.className = "fls-tier";
        row.setAttribute("data-fls-tier", String(min));
        row.innerHTML =
          "<span>" + min + "+ cases</span>" +
          "<span>" + money(unit, moneyFormat) + " / unit</span>" +
          "<span>" + money(unit * units, moneyFormat) + "</span>";
        wrap.appendChild(row);
      });
    }

    function applyVolumeTiers(card) {
      if (!card) return;
      hideSamiTables(card);
      var wrap = card.querySelector("[data-fls-tiers-wrap]");
      var units = parseInt(card.dataset.flsUnits, 10) || 12;
      /* Sami Wholesale volumePricing is the source of truth for case tiers. */
      var vol = volumeTiersForProduct(card.dataset.flsProductId);
      var tiers = [];
      if (vol.length) {
        tiers = vol.map(function (t) {
          return { min: t.min, unit: Math.round(t.total / units) };
        });
      } else {
        var breaks = samiTiers(card);
        if (breaks.length) {
          tiers = breaks.map(function (t) {
            return { min: t.min, unit: Math.round(t.total / units) };
          });
        } else {
          /* Last resort only — do not prefer metafields over Sami. */
          tiers = tiersFor(card);
        }
      }
      if (tiers.length) {
        card.dataset.flsTiers = JSON.stringify(tiers);
      } else {
        delete card.dataset.flsTiers;
      }
      renderCaseTiers(wrap, tiers, units);
    }

    function tierAt(tiers, cases) {
      var hit = tiers[0];
      tiers.forEach(function (t) { if (cases >= t.min) hit = t; });
      return hit;
    }

    /* Sami renders its own quantity-break table into [data-sami-quantity-breaks].
       Read the tiers out of that table so the headline price always matches what the
       customer is actually charged, including custom per-customer pricing. */
    function parseMoney(text) {
      var n = parseFloat(String(text).replace(/[^0-9.,]/g, "").replace(/,/g, ""));
      return isNaN(n) ? null : Math.round(n * 100);
    }

    function samiTiers(card) {
      /* Sami injects its table wherever it likes inside the card, so scan the whole card
         rather than only our own [data-sami-quantity-breaks] hook. */
      var rows = card.querySelectorAll(
        "[data-sami-quantity-breaks] tr, [data-sami-quantity-breaks] [data-fls-tier], " +
        "[data-sami-quantity-breaks] .fls-tier, table tr, .fls-tier"
      );
      if (!rows.length) rows = card.querySelectorAll("tr");
      var out = [];
      rows.forEach(function (row) {
        if (row.querySelector("table")) return;
        var text = (row.textContent || "").replace(/\s+/g, " ").trim();
        var qty = text.match(/(\d+)\s*(?:-|\u2013|\u2014|\+)/);
        if (!qty) return;
        var tokens = text.match(/\$\s?[\d.,]+/g);
        if (!tokens) return;
        var cents = parseMoney(tokens[tokens.length - 1]);
        if (cents == null) return;
        out.push({ min: parseInt(qty[1], 10), total: cents, row: row });
      });
      out.sort(function (a, b) { return a.min - b.min; });
      return out;
    }

    /* Cases already in cart toward volume tiers, keyed by Shopify product id. */
    var cartCasesByProduct = {};

    function ingestCartCases(cart) {
      var map = {};
      var items = (cart && cart.items) || [];
      items.forEach(function (line) {
        if (!line) return;
        var pid = String(line.product_id || "");
        if (!pid) return;
        var qty = parseInt(line.quantity, 10) || 0;
        if (qty <= 0) return;
        map[pid] = (map[pid] || 0) + qty;
      });
      cartCasesByProduct = map;
    }

    function cartCasesForCard(card) {
      var pid = card && card.dataset ? String(card.dataset.flsProductId || "") : "";
      if (!pid) return 0;
      return cartCasesByProduct[pid] || 0;
    }

    function refreshCartCases() {
      return fetch((window.Shopify.routes.root || "/") + "cart.js", {
        headers: { Accept: "application/json" }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          ingestCartCases(cart);
          caseCards.forEach(function (card) { repriceCase(card); });
          return cart;
        })
        .catch(function () { return null; });
    }

    function updateTierNudge(card, cases, units, caseCents, tiers) {
      var el = card.querySelector("[data-fls-tier-nudge]");
      if (!el) return;
      if (!tiers || tiers.length < 2 || !caseCents) {
        el.hidden = true;
        el.textContent = "";
        return;
      }
      var next = null;
      tiers.forEach(function (t) {
        if (t.min > cases && (!next || t.min < next.min)) next = t;
      });
      if (!next) {
        el.hidden = false;
        el.innerHTML = "Best volume price unlocked";
        return;
      }
      var need = next.min - cases;
      var nextCase =
        typeof next.unit === "number"
          ? next.unit * units
          : typeof next.total === "number"
            ? next.total
            : 0;
      if (!nextCase || nextCase >= caseCents) {
        el.hidden = true;
        el.textContent = "";
        return;
      }
      var nextUnit = Math.round(nextCase / units);
      var saveCase = caseCents - nextCase;
      el.hidden = false;
      el.innerHTML =
        "Add <strong>" +
        need +
        "</strong> more case" +
        (need === 1 ? "" : "s") +
        (cases > 0 ? " (" + cases + " in cart)" : "") +
        " to unlock <strong>" +
        money(nextUnit, moneyFormat) +
        " / unit</strong> — save " +
        money(saveCase, moneyFormat) +
        " per case";
    }

    function repriceCase(card) {
      var input = card.querySelector("input[name='quantity']");
      var inputCases = parseInt(input && input.value, 10) || 1;
      var cartCases = cartCasesForCard(card);
      /* Price preview follows the qty field; tier nudge follows cases already in cart
         for this product (falls back to the qty field when the cart is empty). */
      var cases = inputCases;
      var nudgeCases = cartCases > 0 ? cartCases : inputCases;
      var units = parseInt(card.dataset.flsUnits, 10) || 1;
      var priceEl = card.querySelector("[data-fls-qprice]");
      var unitEl = card.querySelector("[data-fls-qunit]");

      var caseCents;
      var nudgeTiers = [];

      /* Sami Wholesale is the source of truth for tier numbers. */
      var vol = volumeTiersForProduct(card.dataset.flsProductId);
      if (vol.length) {
        var samiMapped = vol.map(function (t) {
          return { min: t.min, unit: Math.round(t.total / units), total: t.total };
        });
        card.dataset.flsTiers = JSON.stringify(
          samiMapped.map(function (t) { return { min: t.min, unit: t.unit }; })
        );
        var active = tierAt(samiMapped, cases);
        caseCents = active.total;
        card.querySelectorAll("[data-fls-tier]").forEach(function (row) {
          row.dataset.active = String(parseInt(row.dataset.flsTier, 10) === active.min);
        });
        nudgeTiers = samiMapped;
      } else {
        var breaks = samiTiers(card);
        if (breaks.length) {
          var base = parseInt(card.dataset.flsPriceCents, 10) || 0;
          var inBreak = cases >= breaks[0].min;
          var hit = tierAt(breaks, cases);
          caseCents = inBreak ? hit.total : base;
          breaks.forEach(function (t) {
            if (t.row) t.row.dataset.active = String(inBreak && hit === t);
          });
          nudgeTiers = breaks;
        } else {
          var tiers = tiersFor(card);
          if (!tiers.length) {
            updateTierNudge(card, nudgeCases, units, 0, []);
            return;
          }
          var activeMf = tierAt(tiers, cases);
          caseCents = activeMf.unit * units;
          card.querySelectorAll("[data-fls-tier]").forEach(function (row) {
            row.dataset.active = String(parseInt(row.dataset.flsTier, 10) === activeMf.min);
          });
          nudgeTiers = tiers;
        }
      }

      if (priceEl) priceEl.textContent = money(caseCents, moneyFormat);
      if (unitEl) {
        unitEl.textContent =
          money(Math.round(caseCents / units), moneyFormat) +
          " per unit \u00b7 " + units + " units per case";
        unitEl.querySelectorAll("s, del").forEach(function (n) { n.remove(); });
      }
      updateTierNudge(card, nudgeCases, units, caseCents, nudgeTiers);
    }

    var caseCards = root.querySelectorAll("[data-fls-card][data-fls-units]");
    caseCards.forEach(function (card) {
      applyVolumeTiers(card);
      repriceCase(card);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          hideSamiTables(card);
        }).observe(card, { childList: true, subtree: true });
      }
      setTimeout(function () { applyVolumeTiers(card); repriceCase(card); }, 400);
      setTimeout(function () { applyVolumeTiers(card); repriceCase(card); }, 1400);
      card.addEventListener("change", function () { repriceCase(card); });
      card.addEventListener("input", function () { repriceCase(card); });
    });
    document.addEventListener("samitaWSRenderWholesaleCompleted", function () {
      caseCards.forEach(function (card) {
        applyVolumeTiers(card);
        repriceCase(card);
      });
    });

    refreshCartCases();
    document.addEventListener("fll:cart-changed", function (event) {
      if (event && event.detail && event.detail.items) {
        ingestCartCases(event.detail);
        caseCards.forEach(function (card) { repriceCase(card); });
      } else {
        refreshCartCases();
      }
    });
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) {
          ingestCartCases(event.cartData);
          caseCards.forEach(function (card) { repriceCase(card); });
        } else {
          refreshCartCases();
        }
      });
    }

    /* ---------------- free-shipping sticky bar (wholesale) ---------------- */
    var shipBar = root.querySelector("[data-fls-ship-bar]");
    var shipLine = shipBar && shipBar.querySelector("[data-fls-ship-line]");
    var shipTrack = shipBar && shipBar.querySelector(".fls-bar__track");
    var shipFill = shipBar && shipBar.querySelector("[data-fls-ship-fill]");
    var shipPct = shipBar && shipBar.querySelector("[data-fls-ship-pct]");
    var shipProgress = shipBar && shipBar.querySelector("[data-fls-ship-progress]");
    var shipNote = shipBar && shipBar.querySelector("[data-fls-ship-note]");
    var shipCart = shipBar && shipBar.querySelector("[data-fls-ship-cart]");
    var shipMats = shipBar && shipBar.querySelector("[data-fls-bar-materials]");

    function materialVariantIds() {
      var ids = {};
      root.querySelectorAll("[data-fls-material-check]").forEach(function (el) {
        var id = String(el.value || "");
        if (id) ids[id] = true;
      });
      return ids;
    }

    function cartHasPaidCases(cart) {
      var mats = materialVariantIds();
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var line = items[i];
        if (!line) continue;
        var vid = String(line.variant_id || "");
        if (mats[vid]) continue;
        var qty = parseInt(line.quantity, 10) || 0;
        if (qty > 0) return true;
      }
      return false;
    }

    function cartHasMaterials(cart) {
      var mats = materialVariantIds();
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var line = items[i];
        if (!line) continue;
        var vid = String(line.variant_id || "");
        if (mats[vid]) return true;
        /* Fallback: free line that looks like marketing materials. */
        var price = typeof line.final_price === "number" ? line.final_price : line.price;
        if (price === 0) {
          var hay = ((line.product_title || "") + " " + (line.product_type || "") + " " + (line.title || "")).toLowerCase();
          if (/sample|poster|education|marketing|brochure|handout/.test(hay)) return true;
        }
      }
      return false;
    }

    function updateMaterialsBarCta(cart) {
      if (!shipMats || !shipBar) return;
      var show = !shipBar.hidden && cartHasPaidCases(cart) && !cartHasMaterials(cart);
      shipMats.hidden = !show;
      shipBar.classList.toggle("has-materials-nudge", show);
    }

    function setShipFill(pct) {
      var p = Math.max(0, Math.min(100, pct || 0));
      var ratio = (p / 100).toFixed(4);
      if (shipTrack) {
        shipTrack.style.setProperty("--fls-ship-pct", p + "%");
        shipTrack.style.setProperty("--fls-ship-ratio", ratio);
      }
      if (shipFill) {
        shipFill.style.setProperty("--fls-ship-ratio", ratio);
        shipFill.style.width = "100%";
        shipFill.style.transform = "scaleX(" + ratio + ")";
      }
    }

    function updateShipBar(cart) {
      if (!shipBar || !freeShipping) return;
      var total = cart && typeof cart.total_price === "number" ? cart.total_price : 0;
      var itemCount = cart && cart.item_count ? cart.item_count : 0;
      if (!itemCount) {
        shipBar.hidden = true;
        shipBar.classList.remove("is-met");
        shipBar.classList.remove("has-materials-nudge");
        setShipFill(0);
        if (shipPct) shipPct.textContent = "0%";
        if (shipMats) shipMats.hidden = true;
        return;
      }
      shipBar.hidden = false;
      var rawPct = (total / freeShipping) * 100;
      var pct = Math.max(0, Math.min(100, Math.round(rawPct)));
      /* Tiny cart still shows a visible nub so the bar clearly "starts". */
      var fillPct = total > 0 && pct < 3 ? 3 : pct;
      setShipFill(fillPct);
      if (shipPct) shipPct.textContent = pct + "%";
      if (shipProgress) {
        shipProgress.setAttribute("aria-valuenow", String(pct));
        shipProgress.setAttribute(
          "aria-valuetext",
          pct + "% toward free shipping"
        );
      }
      var remain = freeShipping - total;
      var met = remain <= 0;
      shipBar.classList.toggle("is-met", met);
      if (!met) {
        if (shipLine) {
          shipLine.textContent =
            "Add " + money(remain, moneyFormat) + " more for free shipping";
        }
        if (shipNote) {
          shipNote.textContent =
            money(total, moneyFormat) +
            " of " +
            money(freeShipping, moneyFormat) +
            " toward free shipping";
        }
      } else {
        if (shipLine) shipLine.textContent = "Free shipping unlocked";
        if (shipNote) {
          shipNote.textContent =
            "Cart " + money(total, moneyFormat) + " — threshold met";
        }
      }
      updateMaterialsBarCta(cart);
    }

    function refreshShipBar() {
      if (!shipBar) return Promise.resolve();
      return fetch((window.Shopify.routes.root || "/") + "cart.js", {
        headers: { Accept: "application/json" }
      })
        .then(function (r) { return r.json(); })
        .then(updateShipBar)
        .catch(function () {});
    }

    if (shipCart) {
      shipCart.addEventListener("click", function (event) {
        event.preventDefault();
        var drawer = document.querySelector("cart-drawer");
        if (drawer && typeof drawer.open === "function") drawer.open();
        else if (drawer) {
          drawer.classList.add("animate", "active");
          document.body.classList.add("overflow-hidden");
        }
      });
    }
    if (shipMats) {
      shipMats.addEventListener("click", function (event) {
        event.preventDefault();
        var target =
          root.querySelector("[data-fls-materials]") ||
          document.getElementById("fls-marketing-materials");
        if (!target) return;
        var drawer = document.querySelector("cart-drawer");
        if (drawer && typeof drawer.close === "function") drawer.close();
        document.body.classList.remove("overflow-hidden");
        requestAnimationFrame(function () {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
          target.dataset.flsFlash = "true";
          setTimeout(function () { delete target.dataset.flsFlash; }, 2200);
          try { target.focus({ preventScroll: true }); } catch (e) {}
        });
      });
    }
    function applyCartToShipBar(cart) {
      if (cart && typeof cart.total_price === "number") updateShipBar(cart);
      else refreshShipBar();
    }
    refreshShipBar();
    document.addEventListener("fll:cart-changed", function (event) {
      applyCartToShipBar(event && event.detail);
    });
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        applyCartToShipBar(event && event.cartData);
      });
    }

    /* ---------------- subscriptions (native selling plans) ---------------- */
    root.querySelectorAll("[data-fls-sub]").forEach(function (block) {
      var card = block.closest("[data-fls-card]");
      var form = block.closest("[data-fls-form]");
      var toggle = block.querySelector("[data-fls-sub-toggle]");
      var planInput = block.querySelector("[data-fls-sub-plan]");
      var saveEl = block.querySelector("[data-fls-sub-save]");
      var noteEl = block.querySelector("[data-fls-sub-note]");
      var priceNow = card && card.querySelector("[data-fls-price-now]");
      var priceWas = card && card.querySelector("[data-fls-price-was]");
      var plans = {};
      try { plans = JSON.parse(block.dataset.flsPlans || "{}"); } catch (e) { plans = {}; }

      /* Remember the one-time price so unticking restores it exactly. */
      var baseNow = priceNow ? priceNow.textContent.trim() : "";
      var baseWas = priceWas ? priceWas.textContent.trim() : "";
      var baseWasHidden = priceWas ? priceWas.hasAttribute("hidden") : true;

      function currentPlan() {
        var idInput = form && form.querySelector("[data-fls-variant-id]");
        return idInput ? plans[idInput.value] : null;
      }

      function sync() {
        var plan = currentPlan();
        var on = toggle.checked && !!plan;

        /* No plan for this variant: the option can't apply. */
        block.hidden = !plan;
        if (!plan) {
          toggle.checked = false;
          planInput.disabled = true;
          return;
        }

        planInput.value = plan.plan;
        planInput.disabled = !on;

        if (noteEl) noteEl.textContent = plan.name;

        if (on) {
          if (priceNow) priceNow.textContent = money(plan.price, moneyFormat);
          if (priceWas) {
            priceWas.textContent = baseNow;
            priceWas.removeAttribute("hidden");
          }
          if (saveEl) {
            saveEl.textContent = "You save " + money(basePriceCents(card) - plan.price, moneyFormat) + " per order";
            saveEl.removeAttribute("hidden");
          }
        } else {
          if (priceNow) priceNow.textContent = baseNow;
          if (priceWas) {
            priceWas.textContent = baseWas;
            if (baseWasHidden) priceWas.setAttribute("hidden", "");
          }
          if (saveEl) saveEl.setAttribute("hidden", "");
        }
      }

      /* The one-time price in cents, read back off the rendered price string. */
      function basePriceCents(c) {
        var n = parseFloat((baseNow || "").replace(/[^0-9.]/g, ""));
        return isNaN(n) ? 0 : Math.round(n * 100);
      }

      toggle.addEventListener("change", sync);
      /* Switching size changes both the base price and the plan. */
      if (card) {
        card.addEventListener("click", function (event) {
          if (!event.target.closest("[data-fls-variant]")) return;
          setTimeout(function () {
            baseNow = priceNow ? priceNow.textContent.trim() : "";
            baseWas = priceWas ? priceWas.textContent.trim() : "";
            baseWasHidden = priceWas ? priceWas.hasAttribute("hidden") : true;
            sync();
          }, 0);
        });
      }
      sync();
    });

    /* ---------------- reviews dialog ---------------- */
    var rmodal = root.querySelector("[data-fls-rmodal]") || document.querySelector("[data-fls-rmodal]");
    if (rmodal) {
      var rTitle = rmodal.querySelector("[data-fls-rmodal-title]");
      var rBody = rmodal.querySelector("[data-fls-rmodal-body]");
      var rLink = rmodal.querySelector("[data-fls-rmodal-link]");

      function parkReviews() {
        if (rmodal.parentElement !== document.body) {
          document.body.appendChild(rmodal);
        }
      }
      parkReviews();

      function closeReviews() {
        rmodal.hidden = true;
        rmodal.setAttribute("hidden", "");
        rmodal.style.removeProperty("display");
        rmodal.style.removeProperty("align-items");
        rmodal.style.removeProperty("justify-content");
        rBody.innerHTML = "";
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
      }

      rmodal.querySelectorAll("[data-fls-rmodal-close]").forEach(function (el) {
        el.addEventListener("click", closeReviews);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !rmodal.hidden) closeReviews();
      });

      root.addEventListener("click", function (event) {
        var link = event.target.closest("[data-fls-reviews]");
        if (!link) return;
        event.preventDefault();
        parkReviews();
        rTitle.textContent = link.dataset.flsReviewTitle || "Reviews";
        rLink.href = (link.dataset.flsReviewUrl || "#") + "#looxReviews";

        var amzKey = (link.getAttribute("data-fls-amz-key") || link.dataset.flsAmzKey || "").trim();
        var amzHtml = "";
        if (amzKey) {
          var amzSrc =
            document.querySelector('template[data-fls-amz-source="' + amzKey + '"]') ||
            document.querySelector('[data-fls-amz-source="' + amzKey + '"]') ||
            document.querySelector('.fls-amz-sources [data-fll-amz="' + amzKey + '"]');
          if (amzSrc) {
            if (amzSrc.tagName === "TEMPLATE") {
              amzHtml = amzSrc.innerHTML;
            } else if (amzSrc.getAttribute("data-fll-amz")) {
              amzHtml = amzSrc.outerHTML;
            } else {
              amzHtml = amzSrc.innerHTML;
            }
          }
        }
        var pid = link.dataset.flsReviewProduct || "";
        var parts = [];
        if (amzHtml) {
          parts.push(
            '<div class="fls-rmodal__section">' +
              '<div class="fls-rmodal__kicker">Customer reviews</div>' +
              amzHtml +
            '</div>'
          );
        }
        parts.push(
          '<div class="fls-rmodal__section">' +
            '<div class="fls-rmodal__kicker">Website reviews</div>' +
            '<div id="looxReviews" data-product-id="' + pid + '"></div>' +
          '</div>'
        );
        rBody.innerHTML = parts.join("");

        rmodal.hidden = false;
        rmodal.removeAttribute("hidden");
        rmodal.style.setProperty("display", "flex", "important");
        rmodal.style.setProperty("align-items", "center", "important");
        rmodal.style.setProperty("justify-content", "center", "important");
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
        /* Loox renders into #looxReviews on demand. */
        if (window.loox && typeof window.loox.reload === "function") {
          window.loox.reload();
        } else if (window.Loox && typeof window.Loox.init === "function") {
          window.Loox.init();
        }
      });
    }

    /* ---------------- materials jump / sticky nudges ---------------- */
    function closeDrawer() {
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.close === "function") drawer.close();
      document.body.classList.remove("overflow-hidden");
    }

    var materialsRoot = root.querySelector("[data-fls-materials]");

    function groupFor(card) {
      var key = card && card.dataset.flsMgroup;
      if (!key) return null;
      return root.querySelector('.fls-mcard[data-fls-mgroup="' + key + '"]');
    }

    function materialsTarget(card) {
      return groupFor(card) || materialsRoot || document.getElementById("fls-marketing-materials");
    }

    function scrollToEl(el) {
      if (!el) return;
      closeDrawer();
      requestAnimationFrame(function () {
        var top = el.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        el.dataset.flsFlash = "true";
        setTimeout(function () { delete el.dataset.flsFlash; }, 2200);
        try { el.focus({ preventScroll: true }); } catch (e) {}
      });
    }

    function goToMaterials(card) {
      scrollToEl(materialsTarget(card));
    }

    /* After a case is added: show per-card materials link. */
    function revealMaterialNudges(card) {
      if (!materialsRoot || !card) return;
      var btn = card.querySelector("[data-fls-card-nudge]");
      if (!btn) return;
      btn.hidden = false;
      var group = groupFor(card);
      if (group && group.id) btn.setAttribute("href", "#" + group.id);
      else btn.setAttribute("href", "#fls-marketing-materials");
    }

    root.querySelectorAll("[data-fls-materials-jump]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        goToMaterials(null);
      });
    });

    root.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-fls-card-nudge]");
      if (!btn) return;
      event.preventDefault();
      goToMaterials(btn.closest("[data-fls-card]"));
    });

    /* Match a materials group back to its product card to read the case count. */
    function casesOrderedFor(productTitle) {
      var n = 1;
      if (!productTitle) return n;
      root.querySelectorAll("[data-fls-card]").forEach(function (card) {
        var name = card.querySelector(".fls-card__name");
        if (!name || name.textContent.trim() !== productTitle) return;
        var input = card.querySelector("input[name='quantity']");
        n = parseInt(input && input.value, 10) || 1;
      });
      return n;
    }

    function materialQtyFor(box) {
      var qty = 1;
      var row = box.closest("[data-fls-material-row]");
      if (row && row.hasAttribute("data-fls-sample")) {
        var group = row.closest(".fls-mcard");
        var title = group && group.querySelector(".fls-mcard__title");
        qty = casesOrderedFor(title ? title.textContent.trim() : "");
      }
      return qty;
    }

    function setMaterialBusy(box, busy) {
      box.disabled = !!busy;
      var row = box.closest("[data-fls-material-row]");
      if (row) row.classList.toggle("is-busy", !!busy);
    }

    function removeVariantFromCart(variantId, box) {
      setMaterialBusy(box, true);
      fetch((window.Shopify.routes.root || "/") + "cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).find(function (it) {
            return Number(it.variant_id) === Number(variantId) || Number(it.id) === Number(variantId);
          });
          if (!line) return null;
          return fetch((window.Shopify.routes.root || "/") + "cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: String(line.key || line.id), quantity: 0 })
          }).then(function (r) { return r.json(); });
        })
        .then(function () { return refreshCart(false); })
        .catch(function () { return null; })
        .then(function () {
          if (typeof refreshShipBar === "function") refreshShipBar();
          setMaterialBusy(box, false);
        });
    }

    /* Tick = add to cart immediately; untick = remove. No separate submit button. */
    if (materialsRoot) {
      materialsRoot.addEventListener("change", function (event) {
        var box = event.target.closest("[data-fls-material-check]");
        if (!box) return;
        if (box.checked) {
          setMaterialBusy(box, true);
          addItems(
            [{ id: Number(box.value), quantity: materialQtyFor(box) }],
            null,
            function (ok) {
              setMaterialBusy(box, false);
              if (ok === false) box.checked = false;
            },
            false
          );
        } else {
          removeVariantFromCart(Number(box.value), box);
        }
      });
    }

    /* ---------------- wholesale: recent order reorder ---------------- */
    root.querySelectorAll("[data-fls-reorder]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var raw = btn.getAttribute("data-fls-reorder-items") || "[]";
        var items;
        try { items = JSON.parse(raw); } catch (e) { items = []; }
        if (!items.length) return;
        /* Reorder stays on the page; sticky bar Open cart is the drawer path. */
        addItems(items, btn, null, false);
      });
    });

  }

  document.querySelectorAll("[data-fls-root]").forEach(init);
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-fls-root]");
    if (root) init(root);
  });
})();
